import { EXPORE_ETF_LIST_DATA, EXPORE_ETF_LIST_ERROR, EXPORE_ETF_LIST_HIDE_ERROR, EXPORE_ETF_LIST_START_LOADER, EXPORE_ETF_LIST_STOP_LOADER } from "../interface/iExploreEtfList";
const initialState = {
    data: [],
    errorData: { error: null, isOpen: false },
    loader: false,
};
const exploreEtfListReducer = (state = initialState, action) => {
    switch (action.type) {
        case EXPORE_ETF_LIST_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EXPORE_ETF_LIST_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EXPORE_ETF_LIST_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case EXPORE_ETF_LIST_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EXPORE_ETF_LIST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default exploreEtfListReducer;
